// Copyright (c) 2020-2026 Life and Soft

import { INIT_CONFIGURATION, SET_CONFIGURATION } from "../actions/types";

const initialState = {};

function configurationReducer(state = initialState, action) {
  let configuration = action.payload;
  switch (action.type) {
    case INIT_CONFIGURATION:
    case SET_CONFIGURATION:
      return {
        ...state,
        ...configuration,
      };
    default:
      return state;
  }
}

export default configurationReducer;
